import { ScrollReveal } from "./ScrollReveal";

export const About = () => {
  return (
    <section id="about" className="py-24 bg-secondary">
      <div className="container">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="text-accent font-semibold text-sm uppercase tracking-widest"><span className="text-accent font-semibold text-sm uppercase tracking-widest">Kim jesteśmy?</span></span>
            <h2 className="text-4xl md:text-5xl font-montserrat font-black mt-3 text-foreground">
              O nas
            </h2>
          </div>
        </ScrollReveal>
        <div className="max-w-4xl mx-auto">
          <ScrollReveal delay={100}>
            <div className="glass-light rounded-2xl p-8 md:p-12 shadow-xl">
              <p className="text-lg mb-6 text-muted-foreground leading-relaxed">
                Jesteśmy grupą profesjonalnych artystów kabaretowych z wieloletnim doświadczeniem scenicznym. 
                Specjalizujemy się w występach dla firm, które nie tylko bawią, ale także integrują zespół 
                i tworzą niezapomniane wspomnienia.
              </p>
              <p className="text-lg mb-6 text-muted-foreground leading-relaxed">
                Nasze skecze i programy są zawsze dopasowane do charakteru firmy i potrzeb klienta. 
                Łączymy profesjonalizm z humorem sytuacyjnym, tworząc występy, które rozbawią każdego.
              </p>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Działamy na terenie całej Polski, zapewniając najwyższą jakość kabaretową i gwarancję dobrej zabawy.
              </p>
            </div>
          </ScrollReveal>

          {/* Stats */}
          <ScrollReveal delay={200}>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
              {[
                { number: "999+", label: "Występów" },
                { number: "999+", label: "Firm" },
                { number: "27+", label: "Lat doświadczenia" },
                { number: "100%", label: "Zadowolenia" },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-6 rounded-2xl bg-background shadow-md card-hover">
                  <div className="text-3xl md:text-4xl font-black font-montserrat gradient-text mb-2">{stat.number}</div>
                  <div className="text-sm text-muted-foreground font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};
